const CACHE_KEY = "vizit_shop_reference_cache_v1";
const CACHE_TTL_MS = 30 * 60 * 1000;

let inflightRequest = null;

const readCache = () => {
  if (typeof window === "undefined") {
    return null;
  }

  try {
    const raw = localStorage.getItem(CACHE_KEY);
    if (!raw) {
      return null;
    }

    const parsed = JSON.parse(raw);
    if (!parsed?.expires || parsed.expires <= Date.now()) {
      localStorage.removeItem(CACHE_KEY);
      return null;
    }

    return parsed.data || null;
  } catch {
    return null;
  }
};

const writeCache = (data) => {
  if (typeof window === "undefined") {
    return;
  }

  try {
    localStorage.setItem(
      CACHE_KEY,
      JSON.stringify({
        data,
        expires: Date.now() + CACHE_TTL_MS,
      })
    );
  } catch {
    // ignore quota errors
  }
};

export const getVisitorReferenceCache = () => readCache();

export const ensureVisitorReferenceCache = async (
  axios,
  baseUrl,
  { force = false } = {}
) => {
  if (!force) {
    const cached = readCache();
    if (cached) {
      return cached;
    }
  }

  if (!force && inflightRequest) {
    return inflightRequest;
  }

  inflightRequest = Promise.all([
    axios.get(`${baseUrl}/categories`),
    axios.get(`${baseUrl}/company-categories`),
    axios.get(`${baseUrl}/warehouses`),
  ])
    .then(([categoriesRes, companyCategoriesRes, warehousesRes]) => {
      const data = {
        categories: categoriesRes?.data?.data || [],
        companyCategories: companyCategoriesRes?.data?.data || [],
        warehouses: warehousesRes?.data?.data || [],
      };
      writeCache(data);
      return data;
    })
    .finally(() => {
      inflightRequest = null;
    });

  return inflightRequest;
};
